import script from "./RemoveProductsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveProductsModal.vue?vue&type=script&setup=true&lang=ts"

import "./RemoveProductsModal.vue?vue&type=style&index=0&id=b78f9404&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b78f9404"]])

export default __exports__